import React from 'react';
import { FORM_FIELD, FushaVeprimtarise } from '../../../../utilities/enums';
import { inputStyling } from '../../../../constants/common-style-constants';
import { ColumnsType } from 'antd/es/table';
import { ParticipantData } from '../../../../redux/features/pjesemarres/pjesemarres-api';
import { DropDownResult } from '../../../../components/common/common-componnets/dropDown-singleSelect.component';
import TooltipLayoutComponent from '../../../../components/common/common-componnets/tooltip-layout.component';
import { ReactComponent as Edit } from '../../../../assets/svgIcons/pencil-square.svg';
import { FilterParams } from '../../../AdministrationOfContinuousEducation/liste-prezenca-for-trainings.component';
import { FormField } from '../../../../interfaces/FormInterfaces';
import { kancelar } from '../../../../components/common/common-functions/common-functions';

export const participantsFormFields = (
  institutionInfo: DropDownResult[] | [],
  handleScroll: React.UIEventHandler<HTMLDivElement>,
  setInstitutionParams: (value: (e: FilterParams) => FilterParams) => void,
): FormField[] => {
  return [
    {
      name: 'funksioni',
      type: FORM_FIELD.ANTD_SELECT,
      rules: [
        {
          required: true,
          message: 'Ju lutem zgjidhni një funksion!',
        },
      ],
      label: 'Funksioni',
      options: functionData,
      otherprops: {
        className: inputStyling,
      },
      filterOption: (
        input: string,
        option?: { label: string; value: string },
      ) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
      showSearch: true,
    },
    {
      name: 'fushatVeprimtarise',
      type: FORM_FIELD.ANTD_SELECT,
      rules: [
        {
          required: true,
          message: 'Ju lutem zgjidhni fushen e veprimtarise!',
        },
      ],
      label: 'Fusha veprimtarise',
      options: fushatVeprimtariseData,
      onPopupScroll: handleScroll,
      otherprops: {
        className: inputStyling,
        mode: 'multiple',
      },
      filterOption: (
        input: string,
        option?: { label: string; value: string },
      ) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
      showSearch: true,
    },
    {
      name: 'institucioniId',
      type: FORM_FIELD.ANTD_SELECT,
      rules: [
        {
          required: true,
          message: 'Ju lutem zgjidhni një institucion!',
        },
      ],
      label: 'Institucioni',
      options: institutionInfo,
      onPopupScroll: handleScroll,
      otherprops: {
        className: inputStyling,
      },
      onSearch: (value: string) =>
        setInstitutionParams(e => ({
          ...e,
          page: 0,
          search: value,
          hasMore: true,
        })),
      onDropdownVisibleChange: open => {
        if (!open) {
          setInstitutionParams(e => ({
            ...e,
            page: 0,
            search: '',
          }));
        }
      },
      filterOption: (
        input: string,
        option?: { label: string; value: string },
      ) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
      showSearch: true,
    },
  ];
};

export const functionData = [
  { label: 'Gjyqtar', value: 'GJYQTAR' },
  { label: 'Prokuror', value: 'PROKUROR' },
  { label: 'Avokat Shteti', value: 'AVOKAT_SHTETI' },
  { label: 'Kancelar', value: 'KANCELAR' },
  {
    label: 'Oficer i Policise Gjyqesore',
    value: 'OFICER_I_POLICISE_GJYQESORE',
  },
  { label: 'Keshilltar Ligjor', value: 'KESHILLTAR_LIGJOR' },
  { label: 'Ndihmes Ligjor', value: 'NDIHMES_LIGJOR' },
  { label: 'Kryetar', value: 'KRYETAR' },
  { label: 'Zv. Kryetar', value: 'ZV_KRYETAR' },
  { label: 'Keshilltar', value: 'KESHILLTAR' },
  { label: 'Hetues', value: 'HETUES' },
  { label: 'Hetues Financiar', value: 'HETUES_FINANCIAR' },
  { label: 'Sekretar Gjyqesor', value: 'SEKRETAR_GJYQESOR' },
  { label: 'Pedagog', value: 'PEDAGOG' },
  { label: 'Avokat', value: 'AVOKAT' },
  { label: 'Media', value: 'MEDIA' },
  { label: 'Jurist', value: 'JURIST' },
  {
    label: 'Oficer i Policise se Shtetit',
    value: 'OFICER_I_POLICISE_SE_SHTETIT',
  },
  { label: 'Inspektor', value: 'INSPEKTOR' },
  { label: 'Ndihmes Inspektor', value: 'NDIHMES_INSPEKTOR' },
  { label: 'Pjesemarres i thjeshte', value: 'PJESEMARRES_I_THJESHTE' },
];

export const fushatVeprimtariseData = [
  { label: 'Penale', value: FushaVeprimtarise.PENALE },
  { label: 'Civile', value: FushaVeprimtarise.CIVILE },
  { label: 'Administrative', value: FushaVeprimtarise.ADMINISTRATIVE },
];

export const participantsColumnsData = (
  setSelectedRowData: (data: ParticipantData) => void,
  setShowModal: (data: boolean) => void,
  userRole?: string,
): ColumnsType<ParticipantData> => {
  const columns: ColumnsType<ParticipantData> = [
    {
      title: 'Nr.',
      dataIndex: 'key',
      key: 'key',
      rowScope: 'row',
      align: 'center',
      width: 65,
    },
    {
      title: 'Emri',
      dataIndex: 'emri',
      key: 'emri',
      className: 'w-[20%]',
      ellipsis: {
        showTitle: false,
      },
    },

    {
      title: 'Nr. Personal',
      dataIndex: 'numriPersonal',
      className: 'w-[11%]',
      key: 'numriPersonal',
      align: 'center',
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: 'Funksioni',
      dataIndex: 'funksioni',
      align: 'center',
      key: 'funksioni',
    },
    {
      title: 'Fusha veprimtarisë',
      dataIndex: 'fushatVeprimtarise',
      align: 'center',
      key: 'fushatVeprimtarise',
      ellipsis: {
        showTitle: false,
      },
      render: fushat => {
        if (!fushat || fushat.length === 0) return '-';

        const fushatLabels = fushat
          .map((fusha: string) => {
            const found = fushatVeprimtariseData.find(f => f.value === fusha);
            return found ? found.label : fusha;
          })
          .join(', ');

        return (
          <TooltipLayoutComponent
            text={fushatLabels}
            placement="leftTop"
            arrow={false}
          />
        );
      },
    },
    {
      title: 'Institucioni',
      dataIndex: 'emriInstitucionit',
      key: 'emriInstitucionit',
      align: 'center',
      ellipsis: {
        showTitle: false,
      },
      render: address => (
        <TooltipLayoutComponent
          text={address}
          placement="leftTop"
          arrow={false}
        />
      ),
    },
  ];

  if (userRole !== kancelar) {
    columns.push({
      key: 'action',
      dataIndex: 'status',
      width: 120,
      align: 'center',
      render: (_, record) => (
        <>
          <div className="flex items-center justify-center gap-3.5">
            <TooltipLayoutComponent
              text="Përditëso Pjesëmarrës"
              showText={false}
            >
              <button
                className="edit-btn"
                onClick={() => {
                  setShowModal(true);
                  setSelectedRowData(record);
                }}
              >
                <Edit fill="#014e9e" />
              </button>
            </TooltipLayoutComponent>
          </div>
        </>
      ),
    });
  }

  return columns;
};

export const initialParticipantsValues = (
  selectedRowData: ParticipantData | undefined,
) =>
  selectedRowData
    ? [
        {
          name: 'funksioni',
          value: selectedRowData?.funksioni,
        },
        {
          name: 'institucioniId',
          value: selectedRowData?.institucioniLabel,
        },
        {
          name: 'fushatVeprimtarise',
          value: selectedRowData?.fushatVeprimtarise,
        },
      ]
    : [];
